/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActivityCategoryEnums {
    INSURED_RECORD_ADDED = 1,
    INSURED_RECORD_UPDATE = 3,
    INSURED_RECORD_DELETED = 4,
    INSURED_PRIMARY_ADDRESS_CHANGED = 5,
    INSURED_BILLING_ADDRESS_CHANGED = 6,
    INSURED_LOCATION_ADDED = 7,
    INSURED_LOCATION_UPDATED = 8,
    INSURED_LOCATION_DELETED = 9,
    INSURED_NAME_ADDED = 10,
    INSURED_NAME_UPDATED = 11,
    INSURED_NAME_DELETED = 12,
    INSURED_PRIMARY_CONTACT_CHANGED = 13,
    INSURED_CONTACT_ADDED = 14,
    INSURED_CONTACT_UPDATED = 15,
    INSURED_CONTACT_DELETED = 16,
    INSURED_INCLUDED_OFFICER_ADDED = 17,
    INSURED_EXCLUDED_OFFICER_ADDED = 18,
    INSURED_INCLUDED_OFFICER_UPDATED = 19,
    INSURED_EXCLUDED_OFFICER_UPDATED = 20,
    INSURED_INCLUDED_OFFICER_DELETED = 21,
    INSURED_EXCLUDED_OFFICER_DELETED = 23,
    SECURITY_NEW_USER_ADDED = 24,
    SECURITY_USER_UPDATED = 25,
    SECURITY_USER_DELETED = 26,
    SECURITY_USER_ADDED_TO_PROGRAM = 27,
    SECURITY_USER_REMOVED_FROM_PROGRAM = 28,
    SECURITY_USER_ADDED_TO_CUSTOMER = 29,
    SECURITY_USER_REMOVED_FROM_CUSTOMER = 30,
    SECURITY_USER_CHANGED_PASSWORD = 31,
    SECURITY_USER_FAILED_LOGIN = 32,
    SECURITY_USER_ACCOUNT_LOCKED = 33,
    SECURITY_USER_ACCOUNT_UNLOCKED = 34,
    AGENCY_NEW_AGENCY_ADDED = 35,
    AGENCY_AGENCY_UPDATED = 36,
    AGENCY_LOCATION_ADDED = 37,
    AGENCY_LOCATION_UPDATED = 38,
    AGENCY_CONTACT_ADDED = 39,
    AGENCY_CONTACT_UPDATED = 40,
    AGENCY_APPOINTMENT_ADDED = 41,
    AGENCY_APPOINTMENT_UPDATED = 42,
    AGENCY_COVERAGE_ADDED = 43,
    AGENCY_COVERAGE_UPDATED = 44,
    INSURED_FILE_ADDED = 45,
    INSURED_FILE_DELETED = 46,
    INSURED_NOTE_ADDED = 47,
    INSURED_NOTE_UPDATED = 48,
    INSURED_NOTE_DELETED = 49,
    CLAIM_INCIDENT_CREATED = 50,
    CLAIM_INCIDENT_UPDATED = 51,
    CLAIM_INCIDENT_DELETED = 52,
    ADMIN_PROGRAM_ADDED = 53,
    ADMIN_PROGRAM_UPDATED = 54,
    ADMIN_PROGRAM_DELETED = 55,
    ADMIN_PROGRAM_POLICY_PERIOD_ADDED = 56,
    ADMIN_PROGRAM_POLICY_PERIOD_UPDATED = 57,
    ADMIN_PROGRAM_POLICY_PERIOD_DELETED = 58,
    ADMIN_PROGRAM_PAY_PLAN_ADDED = 59,
    ADMIN_PROGRAM_PAY_PLAN_UPDATED = 60,
    ADMIN_PROGRAM_PAY_PLAN_DELETED = 61,
    ADMIN_BANK_ACCOUNT_ADDED = 62,
    ADMIN_BANK_ACCOUNT_UPDATED = 63,
    ADMIN_BANK_ACCOUNT_DELETED = 64,
    ADMIN_CLASS_CODE_ADDED = 65,
    ADMIN_CLASS_CODE_UPDATED = 66,
    ADMIN_CLASS_CODE_DELETED = 67,
    ADMIN_CLASS_CODE_RATE_ADDED = 68,
    ADMIN_CLASS_CODE_RATE_IMPORTED = 69,
    ADMIN_CLASS_CODE_RATE_UPDATED = 70,
    ADMIN_CLASS_CODE_RATE_DELETED = 71,
    ADMIN_INSURED_REFERENCE_ADDED = 72,
    ADMIN_INSURED_REFERENCE_UPDATED = 73,
    ADMIN_INSURED_REFERENCE_DELETED = 74,
    CLAIM_CLAIM_CONTACT_ADDED = 75,
    CLAIM_CLAIM_CONTACT_UPDATED = 76,
    CLAIM_CLAIM_CONTACT_DELETED = 77,
    QUOTE_QUOTE_CREATED = 78,
    QUOTE_QUOTE_STATUS_CHANGE = 79,
    QUOTE_QUOTE_BOUND = 80,
    POLICY_RENEWAL_CREATED = 81,
    POLICY_RENEWAL_BOUND = 82,
    POLICY_RENEWAL_STATUS_CHANGE = 83,
    POLICY_ENDORSED = 84,
    CLAIM_CLAIM_FILE_ADDED = 85,
    CLAIM_CLAIM_FILE_UPDATED = 86,
    CLAIM_CLAIM_FILE_DELETED = 87,
    PAYMENT_PAYMENT_RECEIVED = 88,
    RESERVE_RESERVE_UPDATED = 92,
    CLAIM_CLAIM_CASE_ADDED = 93,
    CLAIM_CLAIM_CASE_UPDATED = 94,
    CLAIM_CLAIM_CASE_DELETED = 95,
    CLAIM_CLAIM_LITIGATION_CONTACT_ADDED = 96,
    CLAIM_CLAIM_LITIGATION_CONTACT_UPDATED = 97,
    CLAIM_CLAIM_LITIGATION_CONTACT_DELETED = 98,
    CLAIM_CLAIM_LITIGATION_EVENT_ADDED = 99,
    CLAIM_CLAIM_LITIGATION_EVENT_UPDATED = 100,
    CLAIM_CLAIM_LITIGATION_EVENT_DELETED = 101,
    CLAIM_CLAIM_RESERVE_ADDED = 102,
    CLAIM_CLAIM_RESERVE_UPDATED = 103,
    CLAIM_CLAIM_RESERVE_DELETED = 104,
    CLAIM_CLAIM_PAYMENT_ADDED = 105,
    CLAIM_CLAIM_PAYMENT_UPDATED = 106,
    CLAIM_CLAIM_PAYMENT_DELETED = 107,
    AUDIT_CREATED = 108,
    AUDIT_ORDERED = 109,
    AUDIT_RETURNED = 110,
    AUDIT_COMPLETED = 111,
    AUDIT_RE_ORDERED = 112,
    AUDIT_DISPUTED = 113,
    AUDIT_PERFORMED = 114,
    AUDIT_SENT_TO_BROKER = 115,
    AUDIT_DISPUTE_RESOLVED = 116,
    AUDIT_RESULTS_SENT = 117,
    AUDIT_INVOICE_SENT = 118,
    AUDIT_REFUND_SENT = 119,
    AUDIT_REFUND_CREDITED = 120,
    AUDIT_REMINDER_SENT = 122,
    AUDIT_SENT_TO_COLLECTIONS = 123,
    AUDIT_CANCELLATION_CREATED = 124,
    AUDIT_NON_COMPLIANT = 125,
    CLAIM_CLAIM_NOTE_ADDED = 126,
    INSURED_INSURED_NOTE_ADDED = 127,
    ALERT_ADDED = 128,
    ALERT_DELETED = 129,
    ALERT_ACKNOWLEDGED = 130,
    CLAIM_CLAIM_STATUS_UPDATE = 131,
    INSURED_TASK_ADDED = 132,
    INSURED_TASK_UPDATED = 133,
    INSURED_TASK_DELETED = 134,
    INSURED_TASK_COMPLETED = 135,
    CLAIM_CLAIM_NOTE_REPLIED = 136,
    CLAIM_CLAIM_NOTE_UPDATED = 138,
    CLAIM_CLAIM_NOTE_DELETED = 139,
    INSURED_INSURED_NOTE_REPLIED = 140,
    INSURED_INSURED_NOTE_UPDATED = 142,
    INSURED_INSURED_NOTE_DELETED = 143,
    CLAIM_INSURED_UPDATED = 144,
    CLAIM_INSURED_LOCATION_UPDATED = 145,
    CLAIM_JURISDICTION_UPDATED = 146,
    POLICY_POLICY_DOC_PACKET_PRINTED = 147,
    CLAIM_PAYMENTS_BATCH_CLAIM_PAYMENTS = 148,
    CLAIM_DOCUMENT_PRINTED = 149,
    CLAIM_PAYMENT_PROCESSED = 151,
    CLAIM_PAYMENT_VOIDED = 152,
    INSURED_FILE_UPDATED = 153,
    PAYROLL_REPORT_COMPLETED = 156,
    PAYROLL_REPORT_COMPLETED_AS_NOT_REQUIRED = 157,
    PAYROLL_REPORT_UNCOMPLETED = 160,
    CANCEL_SYSTEM_GENERATED_CANCEL_CREATED = 161,
    CANCEL_USER_GENERATED_CANCEL_CREATED = 162,
    CANCEL_CANCELLATION_PROCESSED = 163,
    CANCEL_CANCELLATION_RESCINDED = 164,
    CANCEL_CANCELLATION_REINSTATED = 165,
    CANCEL_CANCELLATION_DELETED = 166,
    RECOVERY_ADDED = 167,
    ENDORSEMENT_ADDED = 168,
    ENDORSEMENT_BOUND = 169,
    ENDORSEMENT_DELETED = 170,
    CLAIM_LIEN_ADDED = 171,
    CLAIM_WORK_STATUS_CHANGE = 172,
    CLAIM_ADJUSTER_UPDATED = 173,
    CLAIM_LIEN_UPDATED = 174,
    CLAIM_LIEN_DELETED = 175,
    CLAIM_CHANGED_DENIED_FLAG = 176,
    CLAIM_CHANGED_DISPUTED_FLAG = 177,
    CLAIM_CHANGED_POSSIBLE_FRAUD_FLAG = 178,
    CLAIM_CHANGED_LIEN_FLAG = 179,
    FILE_MAIL_ROOM_ADDED = 180,
    CERTIFICATE_PENDING_CREATED = 181,
    CERTIFICATE_ISSUED = 182,
    RELATIONSHIP_LINK_ADDED = 183,
    RELATIONSHIP_LINK_REMOVED = 184,
    ASSIGNMENT_CHANGED = 185,
    CLAIM_CREATED = 186,
    WCPOLS_SUBMITTED = 187,
    PAYMENT_REFUND = 188,
    QUOTE_UNBOUND = 189,
    AUDIT_DOCUMENTS_PRINTED = 190,
    CLAIM_REASSIGNMENT = 191,
    WCPOLS_CANCEL_SUBMITTED = 192,
    WCPOLS_REINSTATE_SUBMITTED = 193,
    WCPOLS_KEY_FIELDS_SUBMITTED = 194,
    AUDIT_REVISED = 195,
    AUDIT_STATUS_CHANGED = 196,
    CLAIM_COPIED = 199,
    CLAIM_MOVED = 200,
}
